import { useState, useRef } from 'react';
import { Link, router } from '@inertiajs/react';
import { route } from '../../utils/route';
import { ExamplesDropdown } from '../smart-list/ExamplesDropdown';

export function EmptyState() {
  const [listText, setListText] = useState('');
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!listText.trim()) return;

    try { sessionStorage.setItem('smart_list_pending', listText); } catch {}
    router.visit(route('cart.smart_list'));
  };

  const handleExample = (example: string) => {
    setListText(prev => prev ? prev + '\n' + example : example);
    textareaRef.current?.focus();
  };

  return (
    <div className="py-12 px-5 max-w-lg mx-auto">
      <div className="text-center mb-8">
        <h2 className="text-[22px] font-semibold text-gray-800 m-0 mb-2">Tu carrito está vacío</h2>
        <p className="text-[15px] text-gray-500 m-0">Decinos qué necesitás y te lo armamos</p>
      </div>

      <form onSubmit={handleSubmit} className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm">
        <textarea
          ref={textareaRef}
          className="w-full min-h-[120px] p-3.5 text-[15px] border-2 border-gray-200 rounded-lg resize-vertical font-[inherit] leading-relaxed focus:outline-none focus:border-purple-500 placeholder:text-gray-400"
          placeholder="Escribí lo que necesitás (no hace falta que sea prolijo)"
          value={listText}
          onChange={(e) => setListText(e.target.value)}
        />
        <div className="flex gap-2.5 mt-4 max-md:flex-col">
          <button
            type="submit"
            className="flex-1 py-3 px-5 text-[15px] font-semibold text-white bg-gradient-to-br from-[#667eea] to-[#764ba2] border-0 rounded-lg cursor-pointer transition-all hover:enabled:opacity-90 hover:enabled:-translate-y-px disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            disabled={!listText.trim()}
          >
            Ver carrito sugerido
          </button>
          <ExamplesDropdown onSelect={handleExample} />
        </div>
      </form>

      <div className="text-center mt-6">
        <span className="text-sm text-gray-400">o</span>
        <div className="mt-2">
          <Link
            href={route('products.index')}
            className="text-green-600 font-medium text-[15px] no-underline hover:text-green-700 hover:underline"
          >
            Ver productos
          </Link>
        </div>
      </div>
    </div>
  );
}
